module.exports = __webpack_public_path__ + "img/ba.c3ca8487.svg";